<template>
    <div class='customer-overview'>
        <page-top :title="$t('pages.overview.title')" :background="'#35b72a'" >
            <div class="box is-radiusless is-borderless" />
        </page-top>

        <div class="section">
            <div class="container">
                <div class="columns">
                    <div class="column">
                        <project-overview-list />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<style lang="scss" scoped>
    @import '../../../global/styles/variables';

    .customer-overview {
        background: $background-blueish;
    }
</style>

<script>
    import ProjectOverviewList from '@/taskflex/projects/components/OverviewList';
    import PageTop from '@/global/components/PageTop';
    import ConversationOverviewList from '@/taskflex/conversations/components/OverviewList';

    export default {
        data() {
            return {
                student: null,
                page: null,
            };
        },

        components: {
            ConversationOverviewList,
            PageTop,
            ProjectOverviewList,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/customers/pages/Overview.vue